import { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import classes from './MenuGeneral.module.scss';
import { MenuContext } from '../../../context/menuContext';
import { GeneralContext } from '../../../context/generalContext';
import MenuRestaurantsDropdown from '../MenuRestaurantsDropdown/MenuRestaurantsDropdown';
import iconDown from '../../../images/icon-down.svg';
import MenuSection from '../MenuSection/MenuSection';
import MenuSectionDropdown from '../MenuSectionDropdown/MenuSectionDropdown';
import { addressesAPI } from '../../../services/GeneralService';
import { menuAPI } from '../../../services/MenuService';
import SkeletonMenu from '../../../Components/Skeleton/SkeletonMenu/SkeletonMenu';

export default function MenuGeneral() {
  const {
    selectedMenuSection,
    setSelectedMenuSection,
    menuSectionTypes,
    selectedMenuSectionType,
    setSelectedMenuSectionType,
  } = useContext(MenuContext);
  const {
    selectedAddress,
    setSelectedAddress,
    setActiveCity,
    subdomainIsActive,
    activeLanguage,
    addressesForTitle,
    addressesForTitle_en,
  } = useContext(GeneralContext);
  // достаем из апи адреса
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();
  const [selectedAddressSlug, setSelectedAddressSlug] = useState('');
  useEffect(() => {
    if (addresses) {
      setSelectedAddressSlug(addresses.filter(address => address.id === selectedAddress)[0]?.slug);
    }
  }, [addresses, selectedAddress]);
  // достаем из апи меню
  const sectionUrl = useParams().section;
  const restaurantUrl = useParams().restaurant;
  const { data: menuData, isLoading } = menuAPI.useFetchAllMenuQuery({
    address: selectedAddressSlug || restaurantUrl,
    category: selectedMenuSection || sectionUrl,
  });
  const [menuSectionsNotEmpty, setMenuSectionsNotEmpty] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [subSections, setSubsections] = useState([]);

  // для фильтрации секций меню на напитки и еду
  const [menuSectionsActive, setMenuSectionsActive] = useState([]);
  // все что не напитки по умолчанию относим к еде
  useEffect(() => {
    if (selectedMenuSectionType === 2) {
      setMenuSectionsActive(menuSectionsNotEmpty.filter(section => section.tag === 'drink'));
    } else {
      setMenuSectionsActive(menuSectionsNotEmpty.filter(section => section.tag !== 'drink'));
    }
  }, [menuSectionsNotEmpty, selectedMenuSectionType]);

  useEffect(() => {
    if (menuData) {
      console.log(menuData);
      setMenuSectionsNotEmpty(menuData.menuSections || []);
      setMenuItems(menuData.menuItems || []);
      setSubsections(menuData.parentSection || []);
    }
  }, [menuData]);

  useEffect(() => {
    // смотрим на адресную строку и устанавливаем соответствующий фильтр адреса
    const pathArr = window.location.pathname.split('/');

    // устанавливаем активный язык
    let languageId;
    if (window.location.pathname.slice(1, 3) === 'en') {
      languageId = 2;
    } else {
      languageId = 1;
    }

    if (addresses) {
      let check;
      addresses.forEach(address => {
        if (languageId === 1 && address.slug === pathArr[3]) {
          setSelectedAddress(address.id);
          setActiveCity(address.cityId);
          check = true;
        }
        if (languageId === 2 && address.slug === pathArr[4]) {
          setSelectedAddress(address.id);
          setActiveCity(address.cityId);
          check = true;
        }
      });

      // если не пройдена проверка и есть что-то вместо адреса в адресной строке
      if (!check && languageId === 1 && pathArr[3]) {
        window.history.pushState(null, null, pathArr.slice(0, -1).join('/'));
      }
      if (!check && languageId === 2 && pathArr[4]) {
        window.history.pushState(null, null, pathArr.slice(0, -1).join('/'));
      }
    }
  }, [addresses]);

  useEffect(() => {
    // смотрим на адресную строку и устанавливаем соответствующий фильтр секции
    const pathArr = window.location.pathname.split('/');

    // устанавливаем активный язык
    let languageId;
    if (window.location.pathname.slice(1, 3) === 'en') {
      languageId = 2;
    } else {
      languageId = 1;
    }

    let check;
    // выбираем секцию меню по названию в адресной строке + вид секции (меню/напитки)
    menuSectionsNotEmpty.forEach(section => {
      // есть ли секция из адресной строки в списке доступных
      if (section.slug === pathArr[pathArr.length - 2] || section.slug === pathArr[pathArr.length - 1]) {
        setSelectedMenuSection(section.id);
        if (section.tag) {
          setSelectedMenuSectionType(menuSectionTypes.find(type => type.type === section.tag)?.id || 1);
        }
        check = true;
      }
      // есть ли выбранная секция в списке доступных
      if (section.id === selectedMenuSection) {
        check = true;
      }
    });
    // если нет - выбираем первую секцию меню из доступных для этого адреса и соответственно меняем адресную строку
    if (!check) {
      setSelectedMenuSection(menuSectionsNotEmpty[0]?.id);
      if (languageId === 1) {
        pathArr[2] = menuSectionsNotEmpty[0]?.slug || pathArr[2];
        if (menuSectionsNotEmpty[0]?.slug) {
          window.history.pushState(null, null, `${pathArr.join('/')}`);
        }
      } else if (languageId === 2) {
        pathArr[3] = menuSectionsNotEmpty[0]?.slug || pathArr[3];
        if (menuSectionsNotEmpty[0]?.slug) {
          window.history.pushState(null, null, `${pathArr.join('/')}`);
        }
      }
    }
  }, [selectedMenuSection, menuSectionsNotEmpty]);

  const [isOpenCtgsModal, setOpenCtgsModal] = useState(false);
  const openCtgsModal = () => {
    setOpenCtgsModal(true);
  };

  // для автодокрутки в категориях меню
  const menuSctionsRef = useRef();
  useEffect(() => {
    if (menuSctionsRef && selectedMenuSection) {
      const el = menuSctionsRef.current?.children.namedItem(selectedMenuSection);
      el?.scrollIntoView();
    }
    window.scrollTo(0, 0);
  });

  // есть ли напитки в этом ресторане
  const [anyDrinks, setAnyDrinks] = useState(true);
  useEffect(() => {
    if (menuSectionsNotEmpty.filter(item => item.tag === 'drink')?.length > 0) {
      setAnyDrinks(true);
    } else {
      setAnyDrinks(false);
    }
  }, [menuSectionsNotEmpty]);

  return (
    <div className={`wrapper ${classes.menuGeneral}`}>
      {subdomainIsActive && selectedMenuSection && menuSectionsNotEmpty.length > 0 && (
        <Helmet>
          <title>
            {`${
              activeLanguage === 1
                ? menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name
                : menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name_en ||
                  menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name
            } ${
              activeLanguage === 1
                ? addressesForTitle[selectedAddress] || ''
                : addressesForTitle_en[selectedAddress] || ''
            } | Brasserie Lambic`}
          </title>
        </Helmet>
      )}
      {subdomainIsActive && !selectedMenuSection && (
        <Helmet>
          <title>
            {activeLanguage === 1
              ? `Меню ${addressesForTitle[selectedAddress] || ''} | Brasserie Lambic`
              : `Menu ${addressesForTitle_en[selectedAddress] || ''} | Brasserie Lambic`}
          </title>
        </Helmet>
      )}
      {!subdomainIsActive && selectedMenuSection && menuSectionsNotEmpty.length > 0 && (
        <Helmet>
          <title>
            {`${
              activeLanguage === 1
                ? menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name
                : menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name_en ||
                  menuSectionsNotEmpty?.filter(section => section.id === selectedMenuSection)[0]?.name
            } | Brasserie Lambic`}
          </title>
        </Helmet>
      )}
      {!subdomainIsActive && !selectedMenuSection && (
        <Helmet>
          <title>{activeLanguage === 1 ? 'Меню | Brasserie Lambic' : 'Menu | Brasserie Lambic'}</title>
        </Helmet>
      )}

      {isLoading && <SkeletonMenu />}
      {!isLoading && menuData && (
        <>
          <div className={classes.menuGeneralLeft}>
            {!subdomainIsActive && (
              <div>
                <p className={classes.menuHeader1}>{activeLanguage === 1 ? 'Ресторан' : 'Restaurant'}</p>
                <div className={classes.dropdown}>
                  <MenuRestaurantsDropdown />
                </div>
              </div>
            )}
            <div className={classes.menuSectionsDiv}>
              {anyDrinks && (
                <div className={classes.menuSectionHeaders}>
                  {menuSectionTypes.map(menuSection => (
                    <p
                      key={menuSection.id}
                      className={
                        menuSection.id === selectedMenuSectionType
                          ? classes.menuSectionHeaderActive
                          : classes.menuSectionHeader
                      }
                      onClick={() => setSelectedMenuSectionType(menuSection.id)}
                    >
                      {activeLanguage === 1 ? menuSection.name : menuSection.name_en}
                    </p>
                  ))}
                </div>
              )}
              {!anyDrinks && <p className={classes.menuHeader1}>{activeLanguage === 1 ? 'Меню' : 'Menu'}</p>}
              {menuSectionsActive.length > 0 && (
                <div
                  className={classes.menuSections}
                  ref={menuSctionsRef}
                  style={{ borderTop: anyDrinks ? 'none' : '1px solid #e3e3e3' }}
                >
                  {(window.innerWidth > 767 ? menuSectionsActive : menuSectionsNotEmpty).map(section => (
                    <Link
                      to={
                        activeLanguage === 1
                          ? window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu'
                            ? `/menu/${section.slug}`
                            : `/menu/${section.slug}/${
                                addresses?.filter(address => address.id === selectedAddress)[0]?.slug
                              }`
                          : window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu'
                            ? `/en/menu/${section.slug}`
                            : `/en/menu/${section.slug}/${
                                addresses?.filter(address => address.id === selectedAddress)[0]?.slug
                              }`
                      }
                      key={section.id}
                      className={
                        selectedMenuSection === section.id
                          ? `${classes.menuSectionItemLink} ${classes.menuSectionItemLinkActive}`
                          : classes.menuSectionItemLink
                      }
                      name={section.id}
                    >
                      <p
                        className={`${classes.menuSectionItem} ${
                          selectedMenuSection === section.id ? `${classes.menuSectionItemActive}` : ''
                        }`}
                        onClick={
                          window.innerWidth > 767 ? () => setSelectedMenuSection(section.id) : () => openCtgsModal()
                        }
                      >
                        {activeLanguage === 1 ? section.name : section.name_en || section.name}
                      </p>
                      <img
                        src={iconDown}
                        alt='arrow down'
                        className={
                          selectedMenuSection === section.id ? `${classes.iconDownDiv}` : `${classes.disabled}`
                        }
                        onClick={() => {
                          if (window.innerWidth <= 767) openCtgsModal();
                        }}
                      />
                    </Link>
                  ))}

                  <MenuSectionDropdown
                    anyDrinks={anyDrinks}
                    isOpen={isOpenCtgsModal}
                    setIsOpen={setOpenCtgsModal}
                    title={activeLanguage === 1 ? 'Выберите раздел меню' : 'Select menu section'}
                    listItems={menuSectionsActive}
                    changeSelectedItem={setSelectedMenuSection}
                    selectedItem={selectedMenuSection}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={classes.menuGeneralRight}>
            <MenuSection menuSectionsNotEmpty={menuSectionsNotEmpty} menuItems={menuItems} subSections1={subSections} />
          </div>
        </>
      )}
    </div>
  );
}
